import * as React from "react";
// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = (React as any)["useId".toString()] as () => string;
export const useId = (staticId?: string) => {
  const id = useReactId();
  return staticId ?? id;
};
